enum AdminMenuTypeStatusGroup {
  WAITING = 1,
  ONGOING,
  CANCEL,
  EXPIRED,
  FINISH
}
export default AdminMenuTypeStatusGroup
